import React, { createContext, useReducer } from 'react';
import api from '../api/api';
import history from '../routes/history';
import { toast } from 'react-toastify';
import { useEffect } from 'react';

const AuthStateContext = createContext();
const AuthDispatchContext = createContext();

function reducer(currentState, newState) {
  return { ...currentState, ...newState };
}

function useAuthState() {
  const context = React.useContext(AuthStateContext);
  if (!context) throw new Error('useAuthState deve ser usado em AuthProvider');

  return context;
}

function useAuthDispatch() {
  const context = React.useContext(AuthDispatchContext);
  if (!context)
    throw new Error('useAuthDispatch deve ser usado em AuthProvider');

  return context;
}

const initialState = {
  token: undefined,
  empresaAtiva: null,
  usuarioNomeLogado: null,
  usuarioIDLogado: null,
  acessos: [],
  autenticado: false,
  error: false,
  loading: false,
  url: null,
  newThema: null,
};

function verifyUrl(dispatch, values) {
  dispatch({ url: values.url });
}

async function handleLogin(dispatch, values) {
  try {
    dispatch({ loading: true });
    const { data } = await api.post('/auth', values, {
      headers: {
        banco: values.empresa,
      },
    });

    if (data.token) {
      api.defaults.headers.Authorization = `Bearer ${data.token}`;
      dispatch({
        token: data.token,
        usuarioNomeLogado: data.nome,
        usuarioIDLogado: data.id,
        ultimaVenda: data.ultimaVenda,
        acessos: data.acessos,
        empresaAtiva: values.empresa,
        autenticado: true,
        loading: false,
        error: false,
        url: values.url,
        newThema: values.newThema,
      });
      const authData = {
        token: data.token,
        usuarioNomeLogado: data.nome,
        usuarioIDLogado: data.id,
        acessos: data.acessos,
        empresaAtiva: values.empresa,
        autenticado: true,
        ultimaVenda: data.ultimaVenda,
        url: values.url,
        newThema: values.newThema,
      };

      sessionStorage.setItem('authData', JSON.stringify(authData));
    } else {
      throw new Error('Usuario ou senha invalidos');
    }
  } catch (error) {
    toast.error('Usuario ou senha Invalidos');

    setTimeout(() => {
      handleLogout(dispatch, values.url);
    }, 1000);
  }
}
async function carregarTema(dispatch, values) {
  await dispatch({
    token: undefined,
    usuarioNomeLogado: null,
    usuarioIDLogado: null,
    acessos: [],
    empresaAtiva: null,
    autenticado: false,
    error: false,
    ultimaVenda: null,
    loading: false,
    url: values.url,
    newThema: values,
  });
}
async function handleCheckUser(dispatch, values) {
  try {
    dispatch({ loading: true });
    const { data } = await api.post('/usuario/consulta', values, {
      headers: {
        banco: values.empresa,
      },
    });

    if (data.codigo_usuario > 0) {
      dispatch({
        token: null,
        usuarioNomeLogado: data.nome_usuario,
        usuarioAppEmail: data.appemail,
        usuarioIDLogado: data.codigo_usuario,
        acessos: data.acessos,
        empresaAtiva: values.empresa,
        autenticado: true,
        ultimaVenda: data.ultimaVenda,
        loading: false,
        error: false,
        url: values.url,
        newThema: values.newThema,
      });
      history.push('/alterasenha');
    } else {
      throw new Error('Usuario não encontrado');
    }
  } catch (error) {
    toast.error('Usuario ou senha Invalidos');
    console.log(error);

    dispatch({
      token: undefined,
      usuarioNomeLogado: null,
      usuarioIDLogado: null,
      acessos: [],
      empresaAtiva: null,
      autenticado: false,
      ultimaVenda: null,
      error: false,
      loading: false,
      url: values.url,
      newThema: null,
    });
  }
}
async function handleLogout(dispatch, url) {
  api.defaults.headers.Authorization = undefined;
  dispatch({
    token: undefined,
    usuarioNomeLogado: null,
    usuarioIDLogado: null,
    acessos: [],
    empresaAtiva: null,
    autenticado: false,
    error: false,
    loading: false,
    ultimaVenda: null,
    url: url,
    newThema: null,
  });
  localStorage.clear();
  sessionStorage.removeItem('authData');
  history.push(`/login/${url}`);
  history.go();
}

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const storedAuthData = sessionStorage.getItem('authData');

    if (storedAuthData) {
      const parsedData = JSON.parse(storedAuthData);
      api.defaults.headers.Authorization = `Bearer ${parsedData.token}`;
      dispatch(parsedData);
    }
  }, []);
  return (
    <AuthStateContext.Provider value={state}>
      <AuthDispatchContext.Provider value={dispatch}>
        {children}
      </AuthDispatchContext.Provider>
    </AuthStateContext.Provider>
  );
}

export {
  verifyUrl,
  AuthProvider,
  useAuthState,
  useAuthDispatch,
  handleLogin,
  handleCheckUser,
  handleLogout,
  carregarTema,
};
